import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=495147c6&scoped=true&lang=html"
import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495147c6",
  null
  
)

export default component.exports